import React, { createContext, useContext, useState } from 'react';
import Toast from '../components/UI/Toast';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'success', options = {}) => {
    const id = Date.now() + Math.random();
    const toast = {
      id,
      message,
      type,
      isVisible: true,
      duration: options.duration || 5000,
      position: options.position || 'top-right'
    };

    setToasts(prev => [...prev, toast]);

    // Auto-remove after duration + animation time
    setTimeout(() => {
      removeToast(id);
    }, toast.duration + 500);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const showSuccess = (message, options = {}) => {
    showToast(message, 'success', options);
  };

  const showError = (message, options = {}) => {
    showToast(message, 'error', options);
  };

  const showWarning = (message, options = {}) => {
    showToast(message, 'warning', options);
  };

  const showInfo = (message, options = {}) => {
    showToast(message, 'info', options);
  };

  const value = {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    removeToast
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      
      {/* Render all toasts */}
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          isVisible={toast.isVisible}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
          position={toast.position}
        />
      ))}
    </ToastContext.Provider>
  );
};

export default ToastContext;
